var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileIdLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.79h3.4l1.672 4.542L9.743 4.79H13V13h-2.277V7.38l-2.017 5.591H7.15L5.16 7.439V13H3V4.79zM8 1C5.99 1 4.46 2.281 4.25 4.158h2.1c.21-.715.84-1.222 1.65-1.222.81 0 1.41.507 1.65 1.222h2.1C11.57 2.28 10.01 1 8 1z",
    fill: "#A4A9B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIdLogo);
export default __webpack_public_path__ + "static/media/mobile-id-logo.08c7378394f5559e11f8e4ec4f5512cd.svg";
export { ForwardRef as ReactComponent };